import gsap from 'gsap'
import Swiper from "swiper"
import { Navigation, Autoplay, FreeMode, EffectFade, EffectCreative, Pagination } from "swiper/modules"
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/free-mode"
import "swiper/css/effect-creative"
import "swiper/css/effect-fade"

export const swiper = () => {
	// banner()
	hexagonsStacked()
	hexagonsInlineSmall()
	hexagonsInlineMedium()
	risk()
	steps()
	informationPanels()
	benefits()
	events()
	imageCarousel()
}

const banner = () => {

	let els = document.querySelectorAll('[data-swiper="gallery"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 'auto',
			grabCursor: true,
			centeredSlides: true,
			loop: true,
			speed: 1200,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
		})
	})
}

const hexagonsStacked = () => {

	let els = document.querySelectorAll('[data-swiper="hexagons-stacked"]')

	if (!els.length || window.innerWidth > 960) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 'auto',
			grabCursor: true,
			spaceBetween: 12,
			speed: 1200,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
		})
	})
}

const hexagonsInlineSmall = () => {

	let els = document.querySelectorAll('[data-swiper="hexagons-inline-small"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 'auto',
			grabCursor: true,
			spaceBetween: 12,
			speed: 1200,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
		})
	})
}

const hexagonsInlineMedium = () => {

	let els = document.querySelectorAll('[data-swiper="hexagons-inline-medium"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 'auto',
			grabCursor: true,
			spaceBetween: 20,
			speed: 1200,
			navigation: {
				// prevEl: el.querySelector('[data-button="previous"]'),
				// nextEl: el.querySelector('[data-button="next"]'),
			},
		})
	})
}

const risk = () => {

	let els = document.querySelectorAll('[data-swiper="risk"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 1.25,
			grabCursor: true,
			spaceBetween: 24,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
			breakpoints: {
				600: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				960: {
					slidesPerView: 3,
					spaceBetween: 36,
				}
			}
		})
	})
}

const steps = () => {

	let els = document.querySelectorAll('[data-animation="steps"]')

	if (!els.length) return false

	els.forEach(el => {

		let container = el.querySelector('[data-swiper="steps"]')

		let carousel = new Swiper(container, {
			modules: [EffectCreative, Pagination],
			effect: 'creative',
			speed: 800,
			allowTouchMove: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: false,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + '</span>';
				},
			},
			creativeEffect: {
				prev: {
					shadow: true,
					translate: [0, 0, -600],
				},
				next: {
					translate: ['100%', 0, 0],
				},
			},
		})

		let start = window.innerHeight < 960 ? 'center 60%' : 'center center',
			end = window.innerHeight < 960 ? 'center 60%' : 'center center'

		ScrollTrigger.create({
			trigger: el.querySelector('[data-el="carousel"]'),
			start: start,
			endTrigger: el.querySelector('[data-row="last"]'),
			end: end,
			pin: true,
			// markers: true,
			onUpdate: (self) => {
				let progress = self.progress

				progress = Math.max(0, Math.min(1, progress))

				const numSlides = carousel.slides.length
			
				let stepIndex
				
				if (numSlides === 1) {
					stepIndex = 0
				} else if (progress >= 1.0) {
					stepIndex = numSlides - 1
				} else {
					stepIndex = Math.min(
						numSlides - 1,
						Math.round(progress * (numSlides - 1))
					)
				}

				if (carousel.activeIndex !== stepIndex) {
					carousel.slideTo(stepIndex)
				}
			}
		})

		let rows = el.querySelectorAll('[data-row]')

		rows.forEach(row => {

			gsap.fromTo(row, {
				opacity: 0.2,
				scale: 0.8,
			}, {
				opacity: 1,
				scale: 1,
				ease: 'power1.out',
				scrollTrigger: {
					trigger: row,
					start: "start 100%",
					end: "center 50%",
					scrub: true,
					// markers: true,
				},
			})

			gsap.fromTo(row, {
				opacity: 1,
				scale: 1,
			}, {
				opacity: 0.2,
				scale: 0.8,
				ease: 'power1.in',
				scrollTrigger: {
					trigger: row,
					start: "center 50%",
					end: "bottom 10%",
					scrub: true,
					// markers: true,
				},
			})

		})
	})
}

const informationPanels = () => {

	let els = document.querySelectorAll('[data-swiper="information-panel"]')

	if (!els.length) return false

	els.forEach(el => {
		let swiper = new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 1.25,
			spaceBetween: 24,
			grabCursor: true,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
			breakpoints: {
				782: {
					slidesPerView: 2.5,
					spaceBetween: 24,
				},
				960: {
					slidesPerView: 3,
					spaceBetween: 36,
				},
			},
			on: {
				slideChange(swiper) {
					el.parentElement.parentElement.dataset.currentSlide = swiper.realIndex + 1;
				},
			},
		})
	})
}

const benefits = () => {

	let els = document.querySelectorAll('[data-swiper="benefits"]')

	if (!els.length) return false

	els.forEach(el => {

		let buttons = el.querySelectorAll('[data-index]')
		let section = el.closest('.benefits')

		let swiper = new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 1.25,
			spaceBetween: 24,
			grabCursor: true,
			navigation: {
				prevEl: section.querySelector('[data-button="previous"]'),
				nextEl: section.querySelector('[data-button="next"]'),
			},
			breakpoints: {
				782: {
					slidesPerView: 2.5,
				},
				960: {
					slidesPerView: 3,
				},
			},
		})

		buttons.forEach(button => {
			button.addEventListener('click', () => {
				swiper.slideTo(button.dataset.index)
			})
		})
	})
}

const events = () => {

	let el = document.querySelector('[data-swiper="events"]')

	if (!el) return

	let dropdown = document.querySelector('[data-calendar-dropdown]')

	let swiper = new Swiper(el, {
		modules: [Navigation],
		allowTouchMove: false,
		navigation: {
			prevEl: el.querySelector('[data-button="previous"]'),
			nextEl: el.querySelector('[data-button="next"]'),
		},
	})

	dropdown.addEventListener('change', (e) => {
		swiper.slideTo(e.target.value);
	})
}

const imageCarousel = () => {
	let els = document.querySelectorAll('[data-swiper="image-carousel"]')
	
	console.log('els')
	console.log(els)

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 1.25,
			spaceBetween: 24,
			grabCursor: true,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
			breakpoints: {
				782: {
					slidesPerView: 2.5,
				},
				960: {
					slidesPerView: 3,
				},
			},
		})
	})
}

export default () => { }